import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root'))

// function adjustBodyHeight() {
//     // Get the current viewport height
//     const viewportHeight = window.innerHeight;
  
//     // Set the body's height dynamically
//     document.body.style.height = `${viewportHeight}px`;
//     document.body.style.overflow = 'hidden'; // Prevent excessive scrolling
//   }
  
//   // Adjust height on load and resize
//   window.addEventListener('load', adjustBodyHeight);
//   window.addEventListener('resize', adjustBodyHeight);
  
//   // Handle orientation changes
//   window.addEventListener('orientationchange', () => {
//     setTimeout(() => {
//       window.scrollTo(0, 1); // Slight scroll to trigger address bar adjustment
//       adjustBodyHeight(); // Recalculate the height
//     }, 300); // Delay to allow the orientation change to settle
//   });
  
//   // Initial adjustment (extra safety)
//   setTimeout(() => {
//     adjustBodyHeight();
//     window.scrollTo(0, 1); // Ensure the address bar is visible at start
//   }, 100);

root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
